export const paths_practice_crn_client_crn = {
    TRANSACTIONS: "/app/practices/{practice_crn}/clients/{client_crn}/transactions",
    MAPPINGS: "/app/practices/{practice_crn}/clients/{client_crn}/mappings",
    ACCOUNTING: "/app/practices/{practice_crn}/clients/{client_crn}/accounting",
} as const

export const paths_no_params = {
    AUTO_EXPORTS: "/app/auto-exports",
    BULK_EXPORT: "/app/bulk-export",
    SMART_RECONCILIATION: "/app/smart-rec",
} as const

export const paths_practice_crn_client_crn_identifier = {
    TRANSACTIONS_SINGLE: "/app/practices/{practice_crn}/clients/{client_crn}/transactions/{identifier}",
    CONNECTS_FAILED: "/app/practices/{practice_crn}/clients/{client_crn}/connects/{identifier}",
} as const


export const paths = Object.assign({}, paths_practice_crn_client_crn, paths_no_params, paths_practice_crn_client_crn_identifier)

export type Pathname = keyof typeof paths
